export default "__VITE_ASSET__EB5_Ki96__"